<template>
    <el-form label-width="100px" :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="名称" required >
            <el-input v-model="form.title" clearable  />
        </el-form-item>
        <el-form-item label="直推" required >
            <el-input v-model="form.team" clearable  />
        </el-form-item>
        <el-form-item label="累计充值" required >
            <el-input v-model="form.recharge" clearable  />
        </el-form-item>
        <el-form-item label="团队奖励" required >
            <el-input v-model="form.rate" clearable  />
        </el-form-item>
        <el-form-item label="月工资" required >
            <el-input v-model="form.salary" clearable  />
        </el-form-item>
        <el-form-item label="附加" required >
            <el-input v-model="form.extra" clearable  />
        </el-form-item>
        
    </el-form>
</template>

<script setup>
import { nextTick, onMounted, ref } from 'vue'
import {rolesEnums} from '@/config/enums'

const form = ref({
    title: '',
    team: '',
    recharge: '',
    rate: '',
    extra: '',
    salary: ''
})
const props = defineProps(['item'])

onMounted(() => {
    nextTick(()=> {
        form.value = Object.assign(form, props.item)
    })
})

defineExpose({form})

</script>

<style lang="less" scoped>
.demo-form-inline {
    justify-content: flex-start;
    display: flex;
    flex-wrap: wrap;
}
.demo-form-inline .el-input {
    --el-input-width: 220px;
}

.demo-form-inline .el-select {
    --el-select-width: 220px;
}
/deep/ .el-radio-group {
    width: 220px;
}
.form-title {
 text-align: left;
 padding-left: 30px;
 margin: 20px auto 10px;
 height: 44px;
 background-color: #f2f2f2;
 border-radius: 5px;
 line-height: 44px;
}
/deep/  .el-form-item {
    align-items: flex-start;
}
</style>